import { render, staticRenderFns } from "./TTDConsult.vue?vue&type=template&id=6d808781"
import script from "./TTDConsult.vue?vue&type=script&lang=js"
export * from "./TTDConsult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports